// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"05a373c1","202":"cbb0db52","217":"a935d619","329":"e737acb0","422":"d4553934"}[chunkId] + ".chunk.js";
};